<template>
    <div></div>
  </template>
  
  <script>
  import {loadStripe} from "@stripe/stripe-js";
  
  export default {
    name: "GoToPremium",
    async mounted() {
      const pKey = process.env.VUE_APP_STRIPE_API_PUBLIC_KEY
      this.stripe = await loadStripe(pKey);
        await this.redirect()
  
      if (this.$route.query && this.$route.query.error == "true" && this.errorCount < 1) {
        this.errorCount++
        alert("Ha habido un error con el pago. Ponte en contacto con nosotros: hola@sele.ai")
        await this.$router.replace({query: {error: false}})
      }
    },
    data() {
      return {
        stripe: null,
        errorCount: 0
      }
    },
    methods: {
      async redirect(anual) {
        const user = this.$root.currentUser.value;
        const isUserLogged = user !== null;
  
        // User is Logged
        if (isUserLogged) {
          // Capturar premium_from de la query si existe
          const premiumFrom = this.$route.query.premium_from;
          
          // Guardar premium_from en la base de datos si existe
          if (premiumFrom) {
            try {
              await this.axios.post('/update-premium-from', {
                premium_from: premiumFrom
              }, {
                headers: {
                  Authorization: this.$root.token.value
                }
              });
              console.log('Premium from guardado:', premiumFrom);
            } catch (error) {
              console.error('Error guardando premium_from:', error);
              // Continuar con el checkout aunque falle este paso
            }
          }
  
          // return
  
          const test = process.env.NODE_ENV === 'development';
  
          let price = "";

          // Obtener los valores reales de los parámetros, no convertirlos a booleanos
          const isAnual = this.$route.query.anual == "true";
          const isWeekly = this.$route.query.weekly == "true";
          const planId = this.$route.query.planId;
          const showDiscount = this.$route.query.discount == "true";
          let mode = "payment";
  
          if (planId === "premium") {
            if (isWeekly) {
              // Plan semanal
              if (showDiscount) {
                // ID del plan semanal con descuento (€2,99/semana)
                price = "price_1RXjJvJQPD7NHKVkThXU8n5t";
              } else {
                // ID del plan semanal sin descuento (€4,99/semana)
                price = "price_1RXjUvJQPD7NHKVkprWCznqL";
              }
              mode = "subscription";
            } else if (isAnual) {
              /* 
              // Plan de pago único (comentado temporalmente)
              if (showDiscount) {
                // ID del plan de pago único con descuento (€9.99)
                price = "price_1RTHUMJQPD7NHKVkc6fXnsac"; 
              } else {
                // ID del plan de pago único sin descuento (€14,99)
                price = "price_1RNKLNJQPD7NHKVkpKsqnaIV";
              }
              */
            } else {
              // Plan mensual
              if (showDiscount) {
                // ID del plan mensual con descuento (€6,99/mes)
                price = "price_1RTHRcJQPD7NHKVkeBEZgicI";
              } else {
                // ID del plan mensual sin descuento (€8,99/mes)
                price = "price_1RNKJIJQPD7NHKVki3ISLOhw";
              }
              mode = "subscription";
            }
          } 
  
          // else if (planId === "pro") {
          //   if (isAnual)
          //       price = "price_1R8rQf4cvmDHQVlSd0GNbfWV";
          //   else
          //       price = "price_1R8r8R4cvmDHQVlSggP7g4X1";
                
          // } 
          
          // Si no se especificó un precio válido, usar un valor predeterminado
          // if (!price) {
          //   price = "price_1R8r7O4cvmDHQVlSRulk1E97"; // Precio por defecto (premium mensual)
          // }

          if (!price) {
            alert("Ha habido un error con el pago. Ponte en contacto con nosotros: hola@sele.ai")
            return;
          }
  
          this.stripe.redirectToCheckout({
            successUrl: (test ? 'http://localhost:8081' : 'https://sele.ai') +
              '/premium/success?session_id={CHECKOUT_SESSION_ID}',
            cancelUrl: (test ? 'http://localhost:8081' : 'https://sele.ai') +
              '/app',
            lineItems: [
              {
                price: price,
                quantity: 1
              }
            ],
            mode: mode,
            customerEmail: user.user_email,
            clientReferenceId: "cus_NiXkx5odTkuUJS"
          });
        }
      },
    },
    watch: {
      "$route.query"(val) {
        if (val.error) {
          alert("Ha habido un error con el pago. Ponte en contacto con nosotros: hola@sele.ai")
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .slide-in-right {
    -webkit-animation: slide-in-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: slide-in-right 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  }
  
  
  /**
   * ----------------------------------------
   * animation slide-in-right
   * ----------------------------------------
   */
  @-webkit-keyframes slide-in-right {
    0% {
      -webkit-transform: translateX(133px);
      transform: translateX(133px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  @keyframes slide-in-right {
    0% {
      -webkit-transform: translateX(133px);
      transform: translateX(133px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  .slide-in-left {
    -webkit-animation: slide-in-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: slide-in-left 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  }
  
  /**
   * ----------------------------------------
   * animation slide-in-left
   * ----------------------------------------
   */
  @-webkit-keyframes slide-in-left {
    0% {
      -webkit-transform: translateX(-133px);
      transform: translateX(-133px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  @keyframes slide-in-left {
    0% {
      -webkit-transform: translateX(-133px);
      transform: translateX(-133px);
      opacity: 0;
    }
    100% {
      -webkit-transform: translateX(0);
      transform: translateX(0);
      opacity: 1;
    }
  }
  
  </style>
  